import gql from 'graphql-tag';

export const GetProductsTeamAndSpaceQuery = gql`
	query GetProductsTeamAndSpaceQuery {
		confluence_tenantContext {
			licensedProducts {
				licenseStatus
				productKey
			}
		}
		user: confluence_atlassianUser {
			id
			team
			confluence {
				hasPersonalSpace
				space {
					id
					key
				}
			}
		}
	}
`;
